$(document).ready(function() {
  /*$('a.site-header__icon.site-header__cart').click(function(e) {
    e.preventDefault();
    window.theme.Product.prototype._showCartPopup();
  });*/
});
